/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountSubscription {
    getFixupPrototypeFunction() { return MasterAccountSubscription.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountSubscription>): MasterAccountSubscription {
        let obj = Object.assign(new MasterAccountSubscription(), model);
        MasterAccountSubscription.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountSubscription>): MasterAccountSubscription {
        if (!model) return null;
        return MasterAccountSubscription.newInstance(<MasterAccountSubscription> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountSubscription) {
        if (!obj) return;

        models.MasterAccountSubscription.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountSubscription): boolean {
        Object.setPrototypeOf(obj, MasterAccountSubscription.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Action will be create for project master creation
     */
    action: string;

    /**
     * Subscription id of user
     */
    subscription_id: string;

}
